import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import { EpisodeGrid } from '@/containers';
import { emptyComplete } from '@/images';
import { EVENT_CONSTANTS } from '@/services';
import {
  selectCompletedEpisodeIds,
  selectPlayerSessionsResult,
  selectUserCompliance,
  useFetchEpisodesQuery,
} from '@/store';

import { EmptyView } from '../EmptyView';

export const Completed = () => {
  const compliance = useSelector(selectUserCompliance);
  const completedEpisodeIds = useSelector(selectCompletedEpisodeIds);
  const { isSuccess: isPlayerSessionsSuccess } = useSelector(
    selectPlayerSessionsResult,
  );

  const {
    data: episodes = [],
    isLoading,
    isSuccess,
  } = useFetchEpisodesQuery(
    {
      episodeIds: completedEpisodeIds,
      compliance,
      includeArchived: true,
    },
    {
      skip: !completedEpisodeIds.length,
    },
  );

  const isEmpty =
    (isPlayerSessionsSuccess && !completedEpisodeIds.length) ||
    (isSuccess && !episodes.length);

  return (
    <Box>
      {isEmpty ? (
        <EmptyView
          title="Complete an episode"
          subtitle="See your completed episodes here once you finish all related quizzes or assessments."
          img={emptyComplete}
        />
      ) : (
        <EpisodeGrid
          isLoading={isLoading}
          episodes={episodes}
          referrer={{
            page: EVENT_CONSTANTS.PAGE.MY_LUMIQ,
            section: EVENT_CONSTANTS.SECTION.COMPLETED,
          }}
        />
      )}
    </Box>
  );
};
